import type { PlayerRatingAllResponse } from '@on3/api';
import {
  ServiceLogo,
  type ServiceType,
} from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import clsx from 'clsx';
import { StarRating } from 'components/UI/StarRating/StarRating';
import { Text } from 'components/UI/Typography/Text';

import { type IndustryComparisonRatingType, sortTypeDict } from './helpers';
import { IndustryComparisonConditionalLink } from './IndustryComparisonConditionalLink/IndustryComparisonConditionalLink';
import styles from './IndustryComparisonDraftFourServicesItem.module.scss';

interface IIndustryComparisonRatingProps extends PlayerRatingAllResponse {
  slug?: string | null;
  selected?: string | null;
}
export const IndustryComparisonDraftServiceItem = ({
  rating,
  stars,
  type,
  slug,
  classYear,
  sport,
  selected,
  link,
  overallRank,
  stateRank,
  positionRank,
}: IIndustryComparisonRatingProps) => {
  const profileLink = `/rivals/${slug}/recruiting/`;

  const href = type?.toLowerCase() === 'on3' ? profileLink : link || '';

  const sortByIndustry = (selected ??
    'consensus') as IndustryComparisonRatingType;

  const isActive = type?.toLocaleLowerCase() === sortTypeDict[sortByIndustry];

  return (
    <div
      className={clsx(styles.serviceItemWrapper, {
        [styles.active]: isActive,
      })}
    >
      <IndustryComparisonConditionalLink
        className={styles.serviceItemContainer}
        href={href}
        isActive={isActive}
        type={type}
      >
        <div className={styles.serviceLogo}>
          <div className={styles.mobileLogoContainer}>
            <ServiceLogo type={type as ServiceType} />
          </div>
          <StarRating
            className={styles.serviceItemStarRating}
            grayRating
            hasBorder={false}
            isBoldRating={false}
            rating={rating}
            small
            sport={sport}
            stars={stars}
            type={type}
            year={`${classYear}`}
          />
        </div>
        <div className={clsx(styles.serviceItemRankingHeaderContainer)}>
          <Text
            aria-label={`${type} National Rank`}
            className={styles.rankingHeader}
            component="span"
            variant="subtitle1"
          >
            Natl
          </Text>
          <Text
            aria-label={`${type} Position Rank`}
            className={styles.rankingHeader}
            component="span"
            variant="subtitle1"
          >
            Pos
          </Text>
          <Text
            aria-label={`${type} State Rank`}
            className={styles.rankingHeader}
            component="span"
            variant="subtitle1"
          >
            St
          </Text>
        </div>
        <div className={styles.serviceItemRankingContainer}>
          <Text className={styles.rank} variant="subtitle1">
            {overallRank ?? '-'}
          </Text>
          <Text className={styles.rank} variant="subtitle1">
            {positionRank ?? '-'}
          </Text>
          <Text className={styles.rank} variant="subtitle1">
            {stateRank ?? '-'}
          </Text>
        </div>
      </IndustryComparisonConditionalLink>
    </div>
  );
};
